import React, { useState } from 'react'
import classes from './Card.module.css'

import { animated as a, config, useSpring } from 'react-spring'

const Card = ({ description, imgUrl, title, workUrl, style}) => {
  return (
    <a.div className={classes.card} style={style}>
      <a href={workUrl}>
        <img alt="portfolio work" src={imgUrl} className={classes.img}/>
      </a>
      <h3 className={classes.title}>{title}</h3>
      <p className={classes.description}>{description}</p>
    </a.div>
  )
}

export default Card
